const container = "_container_udcm8_10";
const input = "_input_udcm8_24";
const ui = "_ui_udcm8_34";
const styles = {
  container,
  input,
  ui
};
export {
  container,
  styles as default,
  input,
  ui
};
//# sourceMappingURL=Toggle.module.css.js.map
